import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ToastContainer from "./components/ToastContainer";
import SettingsLayout from "./components/SettingsLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Deployments from "./pages/Deployments";
import Groups from "./pages/Groups";
import GroupDashboard from "./pages/GroupDashboard";
import Services from "./pages/Services";
import Environments from "./pages/Environments";
import Servers from "./pages/Servers";
import Scans from "./pages/Scans";
import DriftEvents from "./pages/DriftEvents";
import DeploymentRequests from "./pages/DeploymentRequests";
import ApprovePage from "./pages/ApprovePage";
import Reports from "./pages/Reports";
import Profile from "./pages/Profile";

// Release Notes pages
import Releases from "./pages/Releases";
import ReleaseDetail from "./pages/ReleaseDetail";
import ReleaseCreate from "./pages/ReleaseCreate";
import ReleaseExecution from "./pages/ReleaseExecution";
import PendingComponents from "./pages/PendingComponents";

// Phase 6: Release Cycles pages
import ReleaseCycles from "./pages/ReleaseCycles";
import ReleaseCycleDetail from "./pages/ReleaseCycleDetail";
import DeploymentDetail from "./pages/DeploymentDetail";
import MyApprovals from "./pages/MyApprovals";
import ApproveReviewPage from "./pages/ApproveReviewPage";

// Settings pages
import UsersSettings from "./pages/settings/UsersSettings";
import UserRolesSettings from "./pages/settings/UserRolesSettings";
import ApprovalRolesSettings from "./pages/settings/ApprovalRolesSettings";
import DefaultApproversSettings from "./pages/settings/DefaultApproversSettings";
import ApprovalTemplatesSettings from "./pages/settings/ApprovalTemplatesSettings";
import RequestFieldsSettings from "./pages/settings/RequestFieldsSettings";
import AlertConfigsSettings from "./pages/settings/AlertConfigsSettings";
import ApiKeysSettings from "./pages/settings/ApiKeysSettings";
import ServiceTemplatesSettings from "./pages/settings/ServiceTemplatesSettings";
import SectionTypesSettings from "./pages/settings/SectionTypesSettings";

function App() {
  return (
    <AuthProvider>
      <ToastContainer />
      <Routes>
        {/* Public routes - no auth required */}
        <Route path="/login" element={<Login />} />
        <Route path="/approve/:token" element={<ApprovePage />} />

        {/* Authenticated routes with layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="release-cycles" element={<ReleaseCycles />} />
          <Route path="release-cycles/:id" element={<ReleaseCycleDetail />} />
          <Route path="releases" element={<Releases />} />
          <Route path="releases/new" element={<ReleaseCreate />} />
          <Route path="releases/:id" element={<ReleaseDetail />} />
          <Route path="releases/:id/execute" element={<ReleaseExecution />} />
          <Route path="pending-components" element={<PendingComponents />} />
          <Route path="deployments/:id" element={<DeploymentDetail />} />
          <Route path="drift-events" element={<DriftEvents />} />
          <Route path="deployment-requests" element={<DeploymentRequests />} />
          <Route path="deployments" element={<Deployments />} />
          <Route path="scans" element={<Scans />} />
          <Route path="groups" element={<Groups />} />
          <Route path="groups/:id" element={<GroupDashboard />} />
          <Route path="services" element={<Services />} />
          <Route path="environments" element={<Environments />} />
          <Route path="servers" element={<Servers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="approvals" element={<MyApprovals />} />
          <Route
            path="approvals/:approvalId/review"
            element={<ApproveReviewPage />}
          />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Org Settings routes - org admin only */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute requireOrgAdmin>
              <SettingsLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<UsersSettings />} />
          <Route path="users" element={<UsersSettings />} />
          <Route path="user-roles" element={<UserRolesSettings />} />
          <Route path="approval-roles" element={<ApprovalRolesSettings />} />
          <Route
            path="default-approvers"
            element={<DefaultApproversSettings />}
          />
          <Route
            path="approval-templates"
            element={<ApprovalTemplatesSettings />}
          />
          <Route path="request-fields" element={<RequestFieldsSettings />} />
          <Route path="alert-configs" element={<AlertConfigsSettings />} />
          <Route path="api-keys" element={<ApiKeysSettings />} />
          <Route
            path="service-templates"
            element={<ServiceTemplatesSettings />}
          />
          <Route path="section-types" element={<SectionTypesSettings />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
